module.exports = { "default": require("core-js/library/fn/reflect/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/reflect/define-property.js
// module id = 1411
// module chunks = 2